export const HDconsts = {
  betteryWarningThreshold: 60,
  betteryDangerThreshold: 20,
};

export const timePeriodsList = [
  { name: "allData", value: "0" },
  { name: "today", value: Date.now() },
  { name: "custom", value: "custom" },
];

export const maps = {
  defaultZoomValue: 5,
};

export const colors = {
  default: "#778899",
  danger: "#ff7800",
  good: "#4cbb17",
  warning: "#ffd000",
  active: "#0067CE",
};

export const dataValues = {
  temp: "°C",
  percent: "%",
  distance: "cm",
};

export const DeviceTabNamesConst = {
  DeviceInfo: "DeviceInfo",
  DeviceServices: "DeviceServices",
  DeviceData: "DeviceData",
  DeviceDownlink: "DeviceDownlink",
  DeviceAlarms: "DeviceAlarms",
  DeviceContracts: "DeviceContracts",
  DeviceAudit: "DeviceAudit",
  DeviceDebugMessages: "DeviceDebugMessages",
  AppliedConfig: "AppliedConfig",
};

export const servicesViews = {
  installation: "installation",
  services: "service-orders",
  technicians: "technicians",
  serviceCenters: "service-centers",
};

export const servicesViewModes = {
  table: "table",
  grid: "grid",
  map: "map",
};

export const servicesOrderWizardSteps = {
  DEVICE_INFO: "AWZS_DEVICE_INFO",
  BEFORE_SERVICE: "AWZS_BEFORE_SERVICE",
  SERVICE: "AWZS_SERVICE",
  REPLACEMENT: "AWZS_REPLACEMENT",
  CHECK_DATA: "AWZS_CHECK_DATA",
  CAUSES: "AWZS_CAUSES",
  AFTER_SERVICE: "AWZS_AFTER_SERVICE",
};
